import {Injectable} from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import {UserSessionService} from '../services/user-session.service'
import {PERMISSION} from "@generated-backend-types";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class CanActivateGuard  {
  constructor(private readonly router: Router, private readonly authService: UserSessionService, private readonly toastr: ToastrService, private readonly translateService: TranslateService) {
  }

  public canActivate(route: ActivatedRouteSnapshot) {

    const allPermissionsNeeded: PERMISSION[] | undefined = route.data['allPermissionsNeeded'];
    const anyPermissionNeeded: PERMISSION[] | undefined = route.data['anyPermissionNeeded'];
    const showToastIfNeededPermissionsMissing: boolean | undefined = route.data['showToastIfNeededPermissionsMissing'] ?? true;

    let can = this.authService.hasAllPermission(allPermissionsNeeded?? [])
    if (!can && showToastIfNeededPermissionsMissing) {
      this.toastr.warning(  this.translateService.instant('shared.permissions.missing_permission', { missingPermissions: allPermissionsNeeded}));
    }

    if (can && anyPermissionNeeded && anyPermissionNeeded.length > 0) {
      can = this.authService.hasAnyPermission(anyPermissionNeeded)
    }
    return can
  }
}
